"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mall = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var Mall = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Mall, _super);
    function Mall() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分商城接口';
        _this.code = '101035';
        _this.desc = '积分商城接口';
        _this.requestParams = new point_1.MallRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Mall;
}(service_1.BaseService));
exports.Mall = Mall;
//# sourceMappingURL=mall.js.map